module.exports = __webpack_public_path__ + "img/R2.a7d11a85.png";